import { FormattedMessage, useIntl } from 'react-intl';
import { Toggle } from '@ets/design-system';

import { useDispatch, useSelector } from '_common/hooks';
import { restoreObject } from './RecyclePageSlice';

import { ActionBar } from '_common/components';

const Header = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const selectedState = useSelector((state) => state.table.selected);

  const handleRestore = () => {
    Object.keys(selectedState).forEach((sKey) => {
      dispatch(restoreObject({ objectId: sKey }));
    });
  };

  return (
    <ActionBar>
      <ActionBar.Breadcrumb
        path={[
          {
            id: 'recycle',
            name: intl.formatMessage({
              id: 'storage.sidebar.recycleBin',
            }),
          },
        ]}
        testId="recycle-page"
      />
      <Toggle
        variant="standard"
        iconProps={{ icon: 'trash-can-undo', color: 'primary' }}
        onToggle={handleRestore}
        disabled={Object.values(selectedState).length === 0}
        testId="recycle-page-restore"
      >
        <FormattedMessage id="storage.actionBar.restore" />
      </Toggle>
    </ActionBar>
  );
};

export default Header;
